import { init, SearchIndex } from 'emoji-mart';
import data from '@emoji-mart/data';
import { Editor } from 'slate';
import MenuItemComponent from './components/MenuItemComponent';
import type { EditorPlugin } from '../../types/aha-editor';
import MenuPluginFactory from '../MenuPluginFactory/MenuPluginFactory';

export interface ReferenceEmojiObject {
  id: string;
  skins: { native: string; shortcodes: string }[];
}

let emojiInitialized = false;

function ensureInitialized() {
  if (!emojiInitialized) {
    init({ data });
    emojiInitialized = true;
  }
}

const ReferenceEmojiInitPlugin: EditorPlugin = {
  id: 'ReferenceEmojiInitPlugin',
  name: 'ReferenceEmojiInitPlugin',
  handlers: {
    onInit() {
      ensureInitialized();
    },
  },
};

const ReferenceEmojiPlugin = MenuPluginFactory<ReferenceEmojiObject>({
  name: 'emoji-reference',
  triggerCharacter: ':',
  menuItemUniqueKey: 'id',
  minCharacters: 2,
  onSearch: async ({ text, controller }) => {
    text = text.toLowerCase().trim();
    return await SearchIndex.search(text);
  },
  MenuItemComponent,
  onSelect: ({ item, editor, controller }) => {
    Editor.insertText(editor, `${item.skins[0].native} `);
  },
});

export default [ReferenceEmojiInitPlugin, ReferenceEmojiPlugin];
